import {ILoginResponse} from "@/lib/types/auth/ILoginResponse";
import {ILoginRequest} from "@/lib/types/auth/ILoginRequest";
import {api} from "@/lib/api/auth/api";
import {IBanReason} from "@/lib/types/auth/IBanReason";
import {IPhoneNumberAuthRequest} from "@/lib/types/auth/IPhoneNumberAuthRequest";
import {IPhoneNumberVerifyRequest} from "@/lib/types/auth/IPhoneNumberVerifyRequest";
import {IAllowedPhoneAuthCountry} from "@/lib/types/auth/IAllowedPhoneAuthCountry";
import {ISmsCodeStatus} from "@/lib/types/auth/ISmsCodeStatus";

export const authApi = api.injectEndpoints({
    endpoints: build => ({
        login: build.mutation<ILoginResponse, ILoginRequest>({
            query: (body) => ({
                url: '/auth/login',
                method: 'post',
                body
            })
        }),
        phoneNumberAuth: build.mutation<void, IPhoneNumberAuthRequest>({
            query: (body) => ({
                url: '/auth/phone-number/code',
                method: 'post',
                body
            })
        }),
        phoneNumberAllowedCountries: build.query<IAllowedPhoneAuthCountry[], void>({
            query: () => ({
                url: '/auth/phone-number/allowed-countries',
                method: 'get',
            })
        }),
        phoneNumberVerify: build.mutation<ILoginResponse, IPhoneNumberVerifyRequest>({
            query: (body) => ({
                url: '/auth/phone-number/verify',
                method: 'post',
                body
            })
        }),
        phoneNumberCodeStatus: build.query<ISmsCodeStatus, string>({
            query: (phoneNumber) => ({
                url: `/auth/phone-number/code/status/${phoneNumber}`,
                method: 'get',
            })
        }),
        checkRegionRestriction: build.query<void, void>({
            query: () => ({
                url: '/auth/check',
                method: 'get',
            }),
        }),
        banReason: build.query<IBanReason | void, string>({
            query: (userId) => ({
                url: `/auth/${userId}/ban_reason`,
                method: 'get',
            })
        })
    })
})

export const {
    useLoginMutation,
    useCheckRegionRestrictionQuery,
    useBanReasonQuery,
    usePhoneNumberAuthMutation,
    usePhoneNumberVerifyMutation,
    usePhoneNumberAllowedCountriesQuery,
    usePhoneNumberCodeStatusQuery,
} = authApi;
